import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkeletonLoaderPipe } from './skeleton-loader.pipe';
import { SkeletonLoaderComponent } from './skeleton-loader.component';

@NgModule({
    declarations: [
        SkeletonLoaderComponent,
        SkeletonLoaderPipe
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        SkeletonLoaderPipe,
        SkeletonLoaderComponent
    ]
})
export class SkeletonLoaderModule { }
